import React from 'react'
import PropTypes from 'prop-types'
import {CollapsibleList as RmwcCollapsibleList} from '@rmwc/list'
import '@rmwc/list/styles'

const CollapsibleList = ({children, ...otherProps}) => <RmwcCollapsibleList {...otherProps}>{children}</RmwcCollapsibleList>

CollapsibleList.propTypes = {
  children: PropTypes.any
}

export {CollapsibleList}
